export interface WorkflowCallout {
  label: string
  detail: string
}

export interface WorkflowRow {
  id: string
  label: string
  headline: string
  copy: string
  callouts: WorkflowCallout[]
  assetId: string
  screenTitle: string
}

export const workflowRows: WorkflowRow[] = [
  {
    id: 'capture',
    label: 'Capture the coaching moment',
    headline: 'Leave the classroom with the write-up already done',
    copy: 'Type what you saw. Nisa shapes it into focus, observations, and next steps, and connects the update to the goals that teacher is working on.',
    callouts: [
      { label: 'Notes take shape as you write', detail: 'No template to fill in afterward' },
      { label: 'Nisa’s take, next to yours', detail: 'A second read you can keep or cut' },
      { label: 'Linked to active goals', detail: 'The update lands in the right thread' },
    ],
    assetId: 'A2',
    screenTitle: 'Add update · Structured and connected to teacher goals',
  },
  {
    id: 'continuity',
    label: 'Maintain teacher continuity',
    headline: 'Open a teacher and see the whole arc',
    copy: 'Visits, coach notes, recordings, and 1:1s sit in one record in the order they happened, under a standing read of what stands out about this teacher.',
    callouts: [
      { label: 'One record per teacher', detail: 'Observations, video, and 1:1s in sequence' },
      { label: 'What Nisa knows', detail: 'A summary current as of the last visit' },
      { label: 'Shared across coaches', detail: 'Coverage can change without losing the thread' },
    ],
    assetId: 'A4',
    screenTitle: 'Teacher profile · Growth record',
  },
  {
    id: 'prepare',
    label: 'Prepare the next move',
    headline: 'Ask for the thing you would have written yourself',
    copy: 'Ask Nisa drafts weekly summaries, visit prep, and next moves from that teacher’s own record, and shows which goals and touchpoints it drew on.',
    callouts: [
      { label: 'Grounded in the record', detail: 'Goals, curriculum, and recent evidence' },
      { label: 'Shows its work', detail: 'See what it pulled before you trust it' },
      { label: 'You decide what ships', detail: 'Every draft is yours to edit or discard' },
    ],
    assetId: 'A3',
    screenTitle: 'Ask Nisa · Grounded response',
  },
]
